import { Component } from '@angular/core';
import { AddBeerFormPage } from '../../pages/add-beer-form/add-beer-form';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the AddBeerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'add-beer',
  templateUrl: 'add-beer.html',
  styleUrls: ['./add-beer.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class AddBeerComponent {

  constructor(private events: AppEventService) {
    console.log('Hello AddBeerComponent Component');
  }

  showAddBeerForm() {
    // TODO add search term as the initial beer name
    console.log("show add beer form")
    this.events.publish("search:addbeer", true);
    //navigate to the detail screen, with the info preloaded

  }
}
